import { PrescriptionDrugMessages } from './prescription-drug-messages';
import { PrescriptionDrugStock } from './prescription-drug-stock';

export class PrescriptionDrug {
  constructor() {
    this.messages = new PrescriptionDrugMessages();
    this.stock = new PrescriptionDrugStock();
  }

  public id?: string;
  public organizationId?: string;
  public genericName?: string;
  public genericCode?: number;
  public genericCodeString?: string;
  public brandName?: string;
  public erxCode?: string;
  public consumption?: string;
  public status?: string;
  public isOutOfPrescription: boolean = false;
  public consumptionInstruction?: string;
  public persianConsumption?: string;
  public consumptionSNOMEDCode?: string;
  public requestCount?: number;
  public deliverCount?: number;
  public maxCoveredCount?: number;
  public shouldSendToEsalat?: boolean;
  public organizationSharePrice?: number;
  public bulkId?: number;
  public description?: string;
  public typeId?: number;
  public type?: string;
  public shape?: string;
  public serviceNationalNumber?: string;
  public numberOfPeriod?: number;
  public checkCode?: string;
  public checkDeliverCode?: string;
  public basePrice?: number;
  public totalPrice?: number;
  public paidPrice?: number;
  public orgAmount?: number;
  public phaDrugPrice?: string;
  public drugForm?: string;
  public maxDrugPrice?: string;
  public insuranceStatus?: string;
  public isInDoctorSpecialty?: string;
  public requiresBarcodeInquiry?: string;
  public neededToHaveFile?: string;
  public hospitalDrug?: string;
  public maxAge?: string;
  public prefExchangePart?: string;
  public prefExchangePrice?: string;
  public maxCount?: string;
  public otpNeeded?: string;
  public messages: PrescriptionDrugMessages;
  public stock: PrescriptionDrugStock;
  public activeSearch: boolean = false;
  public isSelected: boolean = false;
  public bulkDrugInfos: any[] = [];
  public subscriptionDeliveredInfos: any[] = [];

  public index: number = 0;
  public writeWithBrand?: boolean;
}
